// extracted by mini-css-extract-plugin
export default {"container":"ProgressBar_container__l2Qde","bar":"ProgressBar_bar__JSfYq","progress":"ProgressBar_progress__zf+oW","isCompleted":"ProgressBar_isCompleted__3Y9sg"};